import currency from 'currency.js';

// eslint-disable-next-line import/prefer-default-export
export const formatCurrencyRupiah = number =>
  currency(number, {
    separator: '.',
    decimal: ',',
    symbol: 'Rp',
    pattern: '! #',
  }).format(true);
